var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTooth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6336_1589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875 5L13.125 7.5",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 5L6.875 7.5",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12501 6.23126C3.11954 11.8109 4.95939 16.25 6.56251 17.3859C6.65313 17.4484 6.75864 17.4859 6.86837 17.4945C6.9781 17.5031 7.08816 17.4826 7.18742 17.435C7.28668 17.3875 7.37162 17.3145 7.43364 17.2236C7.49567 17.1327 7.53258 17.027 7.54064 16.9172C7.65626 15.3367 8.12501 12.5 10 12.5C11.875 12.5 12.3438 15.3367 12.4617 16.9164C12.4698 17.0262 12.5067 17.1319 12.5687 17.2228C12.6307 17.3137 12.7157 17.3867 12.8149 17.4343C12.9142 17.4818 13.0243 17.5023 13.134 17.4937C13.2437 17.4851 13.3492 17.4476 13.4399 17.3852C15.0406 16.2484 16.8774 11.8102 16.8774 6.23048C16.8734 5.23851 16.4761 4.28862 15.7727 3.58925C15.0692 2.88987 14.117 2.49814 13.125 2.50001H6.87501C5.88331 2.49876 4.9316 2.89087 4.22861 3.59035C3.52562 4.28983 3.12873 5.23956 3.12501 6.23126Z",
    stroke: "#666666",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6336_1589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTooth);
export default __webpack_public_path__ + "static/media/iconTooth.6bd354335d70fe54d656cd25373fddf4.svg";
export { ForwardRef as ReactComponent };